// extracted by mini-css-extract-plugin
export var numpadContainer = "_o4-1";
export var phoneButton = "_o4-0";